const compareBuild=require("./compare-build"),rsort=(list,loose)=>list.sort(((a,b)=>compareBuild(b,a,loose)));module.exports=rsort;